<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>


        <div class="content-blocks">
            <section class="page-header-section full-view-header vendre-header no-margin">
                <div class="image-block"
                    style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/09/Mask-Group-47-e1631285247735.png')">
                </div>
                <div class="container">
                    <div class="content">
                        <h1 class="h1 white anim fade right">Conditions générales de vente</h1>
                        <h4 class="h4 white anim fade right delay1">Mises à jour le {{update_date}}</h4>
                    </div>
                </div>
            </section>
        </div>
        <section class="free-text-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-8">
                        <div class="cgv-title">1 – OBJET DES PRESENTES CONDITIONS GENERALES DE RESERVATION</div>
                        <p>
                            Le Point de vente EWIGO officie en qualité d’intermédiaire pour le compte de particuliers souhaitant vendre leur véhicule.<br>
                            L’Acheteur, qui a préalablement pris connaissance du descriptif du Véhicule sur le site du Point de vente, ou directement auprès de ce Point de vente,
                            souhaite réserver auprès du Point de vente le Véhicule désigné ci-dessus pour l’acheter, conformément aux présentes conditions générales de réservation qui s’appliquent aux réservations effectuées sur internet ou en Point de vente.
                        </p>
                        <div class="cgv-title">2 – DECLARATIONS PREALABLES</div>
                        <p>L’Acheteur se déclare informé de ce que :
                            <ul>
                                <li>Le Point de vente EWIGO auprès de laquelle la réservation est effectuée est un intermédiaire de vente et qu’elle n’est pas le propriétaire du Véhicule ;</li>
                                <li>La vente se réalisera directement entre le Vendeur (propriétaire du véhicule) et l’Acheteur ;</li>
                                <li>Toute réservation de véhicule directement auprès du Point de vente ou depuis le site internet du Point de vente emporte acceptation préalable, complète et sans réserve des présentes conditions générales.</li>
                            </ul>
                        </p>

                        <div class="cgv-title">3 – FRAIS DE RESERVATION</div>
                        <p>
                            L’Acheteur verse au Point de vente l’acompte de réservation à la signature du bon de réservation, en contrepartie des frais de présentation, d’immobilisation et de re-commercialisation du Véhicule si la vente ne se réalise
                            pas du fait de l’Acheteur.<br>
                            Cette somme sera imputée sur le prix total du Véhicule en cas de réalisation définitive de la vente.<br>
                            Cette somme sera intégralement restituée à l’Acheteur sans délai dans les cas suivants :
                            <ul>
                                <li>Si la vente ne se réalise pas du fait du Vendeur ou du Point de vente ;</li>
                                <li>Si l’Acheteur renonce à l’achat du Véhicule du fait d’un défaut de conformité du Véhicule au regard du descriptif fourni par le Point de vente.</li>
                            </ul>
                            Cette somme restera due au Point de vente :
                            <ul>
                                <li>Si l’Acheteur renonce à l’achat du Véhicule pour convenance personnelle ;</li>
                                <li>Si la vente ne se réalise pas dans les 21 jours suivants la signature du bon de réservation du fait de l’Acheteur.</li>
                            </ul>
                        </p>
                        <div class="cgv-title">4 – DEROULEMENT DE LA VENTE</div>
                        <p>
                            Le Point de vente organise en accord avec l’Acheteur et le Vendeur la présentation et la vente du Véhicule dans les locaux du Point de vente EWIGO la plus proche du lieu où se trouve le Véhicule.<br>
                            L’Acheteur peut également demander à ce que le Véhicule soit livré en un autre lieu, auquel cas le Point de vente indiquera préalablement à l’Acheteur les frais de transport qui lui seront facturés. Le coût de ce transport
                            restera en toute hypothèse à la charge de l’Acheteur, même s’il décide finalement ne pas acheter le Véhicule après le transport de celui-ci.<br>
                            Le règlement du prix se fera exclusivement par l’usage de la plateforme de paiement CASHSENTINEL à l’exclusion de tout autre mode de paiement.<br>
                            Préalablement à l’organisation du rendez-vous de présentation et de cession du Véhicule, l’Acheteur ouvrira un compte CASHSENTINEL et le créditera du prix TTC du Véhicule.<br>
                            L’acte de cession du Véhicule sera signé par l’Acheteur et le Vendeur. Ce dernier peut avoir préalablement signé l’acte de cession et l’avoir remis avec le Véhicule au Point de vente pour la part rétribuant les services
                            du Point de vente.<br>
                            Aussitôt la cession du Véhicule signée, les fonds préalablement crédités sur le compte CASHSENTINEL seront virés au Vendeur, déduction faite de la commission due par ce dernier au Point de vente.<br>
                            Seront alors remis à l’Acheteur les documents suivants :
                            <ul>
                                <li>Certificat d’immatriculation barré ;</li>
                                <li>Carnet d’entretien du Véhicule et/ou factures d’entretien du Véhicule le cas échéant ;</li>
                                <li>Carnet de garantie ;</li>
                                <li>Guide d’utilisation / mode d’emploi du Véhicule si présents ;</li>
                                <li>Procès-verbal de contrôle technique favorable de moins de six mois ;</li>
                                <li>Certificat de non-gage du Véhicule ;</li>
                                <li>Un formulaire de rétractation uniquement si le Vendeur est un professionnel et si la vente se réalise hors du lieu de vente dudit professionnel ;</li>
                                <li>Une fiche descriptive d’état du Véhicule au jour de la vente ;</li>
                            </ul>
                        </p>
                        <div class="cgv-title">5 – NON-SOLLICITATION</div>
                        <p>
                            Si la vente du Véhicule n’est pas réalisée lors du rendez-vous organisé par le Point de vente, l’Acheteur s’engage à ne pas contacter le Vendeur sans l’intermédiaire du Point de vente en vue de l’achat de son véhicule dans un délai
                            de deux mois suivant l’organisation de ce rendez-vous.
                        </p>
                        <div class="cgv-title">6 – ASSURANCE - GARANTIES DU VEHICULE</div>
                        <p>
                            Il est de la responsabilité de l’Acheteur de souscrire pour le Véhicule une assurance prenant effet dès le moment de la vente.<br>
                            Si le Véhicule réservé par l’Acheteur ne dispose plus d’une garantie commerciale du constructeur ou de l’importateur d’au moins six mois à compter de la date d’achat par l’Acheteur, le Véhicule bénéficie d’une
                            Garantie Panne Mécanique de 6 mois minimum.<br>
                            Le carnet de garantie est remis au Client par le Point de vente lors de l’acquisition du Véhicule.<br>
                            L’Acheteur pourra souscrire une extension de garantie supplémentaire jusqu’à 48 mois directement auprès d’un prestataire tiers, selon les conditions commerciales de ce dernier.<br>
                            La Garantie Panne Mécanique s’ajoute à la garantie des vices cachés due par le Vendeur dans les conditions prévues aux articles 1641 à 1648 et 2232 du Code civil :
                            <ul>
                                <li>Article 1641 du Code civil : « Le vendeur est tenu de la garantie à raison des défauts cachés de la chose vendue qui la rendent impropre à l'usage auquel on la destine, ou qui diminuent tellement cet
                            usage que l'acheteur ne l'aurait pas acquise, ou n'en aurait donné qu'un moindre prix, s'il les avait connus. »</li>
                                <li>Article 1648 al. 1er du Code civil : « L'action résultant des vices rédhibitoires doit être intentée par l'acquéreur dans un délai de deux ans à compter de la découverte du vice. »</li>
                            </ul>
                            Si le Vendeur est un professionnel, l’Acheteur / consommateur bénéficie également de la garantie légale de conformité prévue aux articles L217-3 et suivants du Code de la consommation.<br>
                            Il est rappelé que le Point de vente n’est qu’intermédiaire et en aucune façon Vendeur du Véhicule, dont elle n’est à aucun moment propriétaire.
                        </p>

                        <div class="cgv-title">7 - DROIT DE RETRACTATION POSTERIEUR A LA VENTE</div>
                        <p>
                            Si le Vendeur est un particulier : La vente s’effectuant entre particuliers (le Point de vente n’intervient que comme intermédiaire), l’Acheteur est informé qu’il ne bénéficie pas d’un délai de rétractation.<br>
                            Si le Vendeur est un professionnel : Conformément aux articles L. 221-28 du Code de la consommation, dans l’hypothèse où la vente aurait été conclue à distance ou hors de l’établissement du Vendeur, ce dernier
                            informera l’Acheteur qu’il dispose d’un délai de rétractation de quatorze jours sans avoir à donner de motif. Pour exercer son droit de rétractation, sera remis à l’Acheteur un formulaire de rétractation que l’Acheteur
                            devra adresser au Vendeur. L’Acheteur peut en tout état de cause demander un formulaire auprès du Point de vente.<br>
                            En cas d’exercice du droit de rétractation par l’Acheteur, le Vendeur devra procéder au remboursement des sommes versées par l’Acheteur au plus tard dans les 14 jours à compter de la date à laquelle le Vendeur est
                            informé de la décision de l’Acheteur de se rétracter et selon le même moyen de paiement que celui utilisé par l’Acheteur (sauf accord exprès de la part de l’Acheteur pour un remboursement selon un autre moyen de
                            paiement).<br>
                            L’Acheteur devra restituer le Véhicule chez le Vendeur ou au Point de vente à ses frais.<br>
                            L’Acheteur ne sera tenu de payer que la dépréciation du Véhicule survenue pendant que celui-ci était sous la responsabilité de l’Acheteur.<br>
                            Une fiche descriptive d’état du Véhicule au jour de la restitution sera établie et comparée à celle établie au jour de la vente.
                        </p>

                        <div class="cgv-title">8 - TRAITEMENT DES RECLAMATIONS / MEDIATION</div>
                        <p>
                            Pour toute réclamation, l’Acheteur peut contacter le service clientèle du Point de vente dont les coordonnées sont les suivantes : Ewigo {{agency.city}}, {{agency.address}}.<br>
                            Si l’Acheteur n’obtient pas satisfaction auprès du Point de vente, il peut recourir gratuitement au service de médiation de la Commission de Médiation Franchise-Consommateurs (MFC), depuis le site internet : <a href="https://www.mediation-franchise.com/saisir-la-mediation" target="_blank">https://www.mediation-franchise.com/saisir-la-mediation</a> ou par courrier à l’adresse : Médiation Franchise-Consommateurs - 29 Boulevard de Courcelles - 75008 PARIS.
                        </p>

                        <div class="cgv-title">9 - DONNEES PERSONNELLES</div>
                        <p>
                            Les modalités de collecte, utilisation et traitement par l’exploitant du Site internet du Point de vente des données personnelles des utilisateurs naviguant et/ou faisant usage des produits et services proposés sur le site sont
                            indiquées sur la page "Données personnelles" accessible sur le Site.<br><br>
                            Conformément à la loi Informatique et Libertés en date du 6 janvier 1978, l’Acheteur dispose d’un droit d’accès, de rectification, de modification et de suppression concernant les données qui le concerne.
                            L’Acheteur peut exercer ce droit en envoyant un courrier recommandé à l’adresse suivante : Ewigo {{agency.city}}, {{agency.address}}.
                        </p>
                    </div>
                    <div class="col-lg-2"></div>
                </div>
            </div>
        </section>

    </Layout>
    <Footer :agency="agency" :bg_img="bg_img"></Footer>
</template>

<script>
  import _, {throttle} from 'lodash';
  import Layout from './Ads/Layout'
  import { Head } from '@inertiajs/inertia-vue3'
  import Footer from "@/Pages/Partials/Footer"
  import Header from "@/Pages/Partials/Header"
  import Ad from "@/Pages/Partials/Ad"

  export default {
    components: {
      Head,
      Layout,
      Footer,
      Header,
      Ad,
    },
    props: {
      agency: Object,
      title: String,
      description:String,
      bg_img: String,
      body_class: String,
      ads: Object,
      members: Object,
      update_date: String,
    },
    data() {
        return {

        }
    },
    mounted () {
        document.body.classList.add(this.body_class.split(' '))
    },
    destroyed () {
        document.body.classList.remove(this.body_class.split(' '))
    },
  }
</script>
